/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsnoprofile2Inputs */

const en_earningsnoprofile2 = /** @type {(inputs: Earningsnoprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No profile`)
};

const de_earningsnoprofile2 = /** @type {(inputs: Earningsnoprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Profil`)
};

/**
* | output |
* | --- |
* | "No profile" |
*
* @param {Earningsnoprofile2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsnoprofile2 = /** @type {((inputs?: Earningsnoprofile2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsnoprofile2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsnoprofile2(inputs)
	return de_earningsnoprofile2(inputs)
});
export { earningsnoprofile2 as "earningsNoProfile" }